import React, { FC } from 'react';
import Loading from 'src/components/common/Loading';

interface DivisionSwitchingScreenProps {
  divisionName?: string | null;
}

/**
 * Full-bleed white screen rendered inside the layout's main content slot
 * while a division switch is in flight. Header / sidebar stay mounted around
 * it; the page reloads as soon as the switch completes.
 */
const DivisionSwitchingScreen: FC<DivisionSwitchingScreenProps> = ({ divisionName }) => (
  <div
    style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 100px)',
      gap: 16,
      background: '#fff',
      color: '#031425',
      fontFamily: 'Roboto, sans-serif',
      fontSize: 16
    }}
  >
    <Loading />
    <div>Switching to {divisionName || 'division'}...</div>
  </div>
);

export default DivisionSwitchingScreen;
